import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import './home.css'
import logo from '../Assets/proLogo.jpg'
import gemeni from '../Assets/geminiLogo.jpg'
import you from '../Assets/you.jpg'

const Home = () => {
  const { isLoading, isError, error, allData, showingValue, isEmpty, getResponse } = useSelector(state => state.Store)

  const [animatedText, setAnimatedText] = useState('')
  const [index, setIndex] = useState(0)

  const processText = (text) => {
    if (!text) return ""
    return text
    .replace(/^\*\s/gm, "") // remove single '*' used as bullet points at line start
    .replace(/\*\*\*(.*?)\*\*\*/g, "<b><i>$1</i></b>") // bold italic
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")            // bold
    .replace(/\*(.*?)\*/g, "<i>$1</i>")                // italic
    .replace(/\n/g, "<br />");                         // new lines
};


  useEffect(() => {
    if (getResponse === true && !isError && allData) {
      const parsed = processText(allData)
      setAnimatedText('')
      setIndex(0)

      let i = -1
      const interval = setInterval(() => {
        setAnimatedText(prev => prev + parsed.charAt(i))
        i++
        if (i >= parsed.length) clearInterval(interval)
      }, 10)

      return () => clearInterval(interval)
    }
  }, [getResponse, isError, allData])

  return (
    <div className='HomeSection'>
      {isEmpty === true ? <div className='Empty'>
        <img src={logo} alt="logo" className='logo' />
        <h1>How can I help You ?</h1>
      </div> : <div className="userInput">
        <p>{showingValue}</p>
        <img src={you} alt="you" />
      </div>}

      {isLoading === true ? <div className='loading'>
        <img src={gemeni} alt="logo" />
        <div>✦  ✦  ✦</div>
      </div>
        :
        null
      }
      {getResponse === false ? null :
        <div className='response'>
          <img src={gemeni} alt="gemeni" className='gemeniLogo' />
          {isError === true ? <p className='responsePara'>Falied To Response.... <br /> Cheack Your Internet Connection</p> :
            <p className='responsePara' dangerouslySetInnerHTML={{ __html: animatedText }}></p>}
        </div>
      }
    </div>
  )
}

export default Home

